module.exports = "https://static.wmbcdn.com/uniweb/images/aee83759e9584a1ebe4f299df2e60482.svg";